import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useSpareLibrary, SpareLibrary } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<SpareLibrary>
    useData={useSpareLibrary}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
